import { fanStep } from "./measure";
/**
 * Your hand: where every card lies in the hand slot. The hand and the deal share
 * it, so a dealt card lands exactly where it will stay.
 */
/** A playable card rises this share of its height on hover or focus (design: 30 of 196). */
export const HAND_LIFT = 0.15;
/** The fan bends as if the cards turned about a point this many card heights below them. */
const PIVOT = 5;
/** Left edge of each card in a row `slotW` wide, the row centred, `show` of each card left showing. */
export function handLefts(slotW, cardW, count, show) {
    const step = Math.min(fanStep(slotW, cardW, count), cardW * show);
    const offset = (slotW - (cardW + Math.max(0, count - 1) * step)) / 2;
    return Array.from({ length: count }, (_, i) => offset + i * step);
}
/** How many cards fit one row of the slot at the fan's spacing. */
function perRow(canvas) {
    const { w } = canvas.card;
    return Math.floor((canvas.elements.hand.w - w) / (w * canvas.handFan.show)) + 1;
}
/** One row of the fan, centred, its middle card upright and its ends tilted and lower. */
function row(canvas, count, y, z) {
    const { w, h } = canvas.card;
    const fan = canvas.handFan;
    const mid = (count - 1) / 2;
    return handLefts(canvas.elements.hand.w, w, count, fan.show).map((left, i) => {
        const rotate = (i - mid) * fan.tilt;
        const dip = h * PIVOT * (1 - Math.cos((rotate * Math.PI) / 180));
        return { x: left + w / 2, y: y + dip, rotate, z: z + i };
    });
}
/**
 * Every card of a hand of `count`, in hand order. One flat row on phones; on the
 * wide canvas a fan, in two rows once it no longer fits one (owner, 11 Sept: "show
 * the faces of the court cards"): the first half behind, the rest in front.
 */
export function handPlaces(canvas, count) {
    const fan = canvas.handFan;
    const front = canvas.elements.hand.h - fan.raise;
    if (fan.tiers === 1 || count <= perRow(canvas))
        return row(canvas, count, front, 0);
    const back = Math.ceil(count / 2);
    return [...row(canvas, back, front - fan.tierGap, 0), ...row(canvas, count - back, front, back)];
}
//# sourceMappingURL=hand.js.map